var Aneox;
(function (Aneox) {
  'use strict';

  var Menu = (function () {

    var animations;
    var scroll;
    var isOpen = false;

    var menu;
    var menuButton;
    var floating;

    var isFloatingMenuOpen = false;

    function Menu(anims, scrolling) {
      animations = anims;
      scroll = scrolling;
      menu = $('#menu');
      menuButton = $('#menu-button');
      floating = $('.floating');

      $('.js-menu-link').click(close);
      $('#menu-link-domain').click(function() {
        close({ closeFloating: false });
      });

      $('[router-locale]').click(function() {
        if (isFloatingMenuOpen) {
          isFloatingMenuOpen = false;
        } else {
          setTimeout(openFloating, 100);
        }
      });
    }

    function open() {
      isFloatingMenuOpen = !menuButton.hasClass('floating-hidden');
      scroll.cancelManualScroll();
      scroll.incrementScrollRetainCount();
      openFloating();
      animations.openOverlay(menu);
      menuButton.addClass('open');
      isOpen = true;
    }

    function close(options) { 
      if (options.closeFloating === false) {
        setTimeout(openFloating, 50);
      } else {
        setTimeout(closeFloating, 50);
      }
      animations.closeOverlay(menu);
      menuButton.removeClass('open');
      isOpen = false;
      scroll.decrementScrollRetainCount();
    }

    Menu.prototype.toggle = function() {
      if (isOpen) {
        close({ closeFloating: !isFloatingMenuOpen });
      } else {
        open();
      }
    };

    Menu.prototype.open = open;

    function openFloating() {
      floating.removeClass('floating-hidden');
    };

    function closeFloating() {
      floating.addClass('floating-hidden');
    };

    Menu.prototype.toggleFloating = function() {
      floating.toggleClass('floating-hidden');
    };

    Menu.prototype.handleWindowResize = function(bodyWidth, bodyHeight) {
      if (!isOpen) {
        TweenMax.set('#menu-wrapper', { y: bodyHeight / 2 });
      }
    };

    return Menu;
  })();

  Aneox.Menu = Menu;
})(Aneox || (Aneox = {}));